import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Define initial state
const initialState = {
  tenders: [],
  push_purchase: [],
  loading: false,
  error: null,
};

// Create async thunk for fetching all tenders
export const fetchTenders = createAsyncThunk(
  'tenders/fetchTenders',
  async ({ id, status }) => {
    const response = await axios.get(`${API_URL}/tenders/${id}?status=${status}&user_id=${localStorage.getItem('user_id')}`);
    return response.data.data;
  }
);

// Create async thunk for creating a tender
export const createTender = createAsyncThunk(
  'tenders/createTender',
  async ({ id, tenderData }) => {
    const response = await axios.post(`${API_URL}/tenders/${id}`, tenderData);
    return response.data.data;
  }
);




// Create async thunk for updating a tender
export const updateTender = createAsyncThunk(
  'tenders/updateTender',
  async ({ id, tenderData }) => {
    const response = await axios.put(`${API_URL}/tenders/${id}`, tenderData);
    return response.data.data;
  }
);

// Create async thunk for deleting a tender
export const deleteTender = createAsyncThunk(
  'tenders/deleteTender',
  async (id) => {
    await axios.delete(`${API_URL}/tenders/${id}`);
    return id;
  }
);



// Create async thunk for creating a tender
export const getPushedForPurchase = createAsyncThunk(
  'tenders/getPushedForPurchase',
  async ({id, status = ""}) => {
    const response = await axios.get(`${API_URL}/tenders/push/purchase/${id}?status=${status}`);
    return response.data.data;
  }
);

// Create slice
const tenderSlice = createSlice({
  name: 'tenders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTenders.fulfilled, (state, action) => {
        state.loading = false;
        state.tenders = action.payload;
      })
      .addCase(fetchTenders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getPushedForPurchase.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPushedForPurchase.fulfilled, (state, action) => {
        state.loading = false;
        state.push_purchase = action.payload;
      })
      .addCase(getPushedForPurchase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createTender.fulfilled, (state, action) => {
        state.tenders.push(action.payload);
      })
      .addCase(updateTender.fulfilled, (state, action) => {
        const index = state.tenders.findIndex(
          (tender) => tender.id === action.payload.id
        );
        if (index !== -1) {
          state.tenders[index] = action.payload;
        }
      })
      .addCase(deleteTender.fulfilled, (state, action) => {
        state.tenders = state.tenders.filter(
          (tender) => tender.id !== action.payload
        );
      });
  },
});

export default tenderSlice.reducer;
